<div class="mb-2">
	@if (!modal) {
		<div class="flex justify-content-between align-items-center mb-2">
			<h1 class="flex align-items-center m-0">
				<back-button class="flex-shrink-0"></back-button>
				<vignette-display [vignette]="ressource.vig_id" class="mr-2 flex-shrink-0"></vignette-display>
				<span>{{ressource.res_titre}}</span>
				<favori-toggle-button class="flex-shrink-0" [ressource]="ressource"></favori-toggle-button>
			</h1>
			<div class="flex-shrink-0">
				@if (menuItems.length) {
					<button
						type="button"
						pButton
						icon="pi pi-bars"
						class="label-md-none"
						[loading]="loading"
						(click)="menu.toggle($event)"
					></button>
				}
				<p-menu #menu [popup]="true" [model]="menuItems" appendTo="body"></p-menu>
			</div>
		</div>
	}

	@if (ressource.nb_medias_telechargeables || ressource.res_html) {
		<div class="grid">
			@if (ressource.nb_medias_telechargeables) {
				<div class="col-12 xl:col">
					<p-card>
						<h3>{{mediaPanelTitle}}</h3>
						<medias-display [medias]="ressource.medias" [showVisibilitePartielle]="true" (onMediaClick)="_onMediaClick($event)"></medias-display>
					</p-card>
				</div>
			}

			@if (ressource.res_html) {
				<div class="col-12 xl:col">
					<p-card>
						<ressource-renderer [ressource]="ressource" (onMediaClick)="_onMediaClick($event)"></ressource-renderer>
					</p-card>
				</div>
			}
		</div>
	}


	<p-card class="ressource-meta text-sm">
		@if (ressource.res_version) {
			<div>
				Version : {{ressource.res_version}}
			</div>
		}
		<div>Dernière mise à jour : {{ressource.res_date_modification|date: 'medium'}}</div>
		@if (ressource.mots_clefs.length) {
			<div>Mots-clefs :
				<span class="ressource-mot-clefs">
					@for (keyword of ressource.mots_clefs; track keyword) {
						<small class="keyword">{{keyword}}</small>
					}
				</span>
			</div>
		}

		@if (ressource.hasResponsabilites()) {
			<div class="grid grid-nogutter">
				<div class="col-fixed flex-shrink-0">Responsable(s) :</div>
				<div class="col pl-1"><relation-display [value]="ressource.responsabilites" [showLabels]="true"></relation-display></div>
			</div>
		}
	</p-card>

</div>



<p-galleria
	[value]="images"
	[(visible)]="showLighbox"
	[circular]="true"
	[fullScreen]="true"
	[(activeIndex)]="activeImageIndex"
	[showItemNavigators]="true"
	[baseZIndex]="1000"
>
	<ng-template pTemplate="item" let-item>
		<div class="text-white flex center-all w-full h-full flex-column align-items-stretch ">
			<div class="text-center font-bold p-3">
				{{item.med_titre}}
			</div>

			@if (item) {
				<media-display [media]="item" [consultation]="true" class="flex center-all w-full h-full"></media-display>
			}

			@if (item.med_description) {
				<div class="text-center p-3">
					{{item.med_description}}
				</div>
			}
		</div>
	</ng-template>
	<ng-template pTemplate="thumbnail" let-item>
		<media-display [media]="item" class="block"></media-display>
	</ng-template>
</p-galleria>
